export default {
  services: {
    title: 'Select the services you need.',
    subtitle:
      "You can choose as many services as you'd like, but the fewer services you select the more you'll save!",
    trySearchingSearchBox:
      "Didn't find what you were looking for? More services can be found in the Search Box above.",
    lookingForMore: 'Looking for more services? Use the filters above or view more services',
    popularSection: {
      title: 'Popular Services',
    },
    filters: {
      searchLabel: 'Find More Services',
      genreLabel: 'Filter Services By Genre',
      filterByGenres: 'Filter By Genres',
    },
  },
  questions: {
    internet_speed: {
      question: 'How fast is your internet?',
      answers: {
        answer1: 'Slow',
        answer2: 'Medium',
        answer3: 'Fast',
      },
    },
    internet_bill: {
      question: 'How much do you pay for your internet?',
    },
    cable_tv: {
      question: 'Do you have cable TV?',
      answers: {
        answer1: 'Yes',
        answer2: 'No',
      },
    },
    cable_tv_bill: {
      question: 'How much is your monthly cable TV bill?',
    },
  },
  results: {
    title: 'Here are your results',
    monthlyBill: {
      title: 'Your Current\nMonthly Bill',
    },
  },
};
